export default "__VITE_ASSET__BfZPArxK__"